import React from 'react'
import {
   AIPoweredGamingIcon,
   AIPoweredLogisticsAnalyticsIcon,
   ContinuousSupportIcon,
   CustomGameSolutionsIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SeamlessMultiplayerIntegrationIcon,
   SecureBlockchainGamingIcon,
   SupplySecureCompliantPlatformsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: "Custom Game Solutions",
      subtitle: "Tailored Platforms for Gamers & Developers",
      description:
         "We build custom game engines, esports platforms, and mobile gaming applications, ensuring seamless gameplay experiences.",
      icon: <CustomGameSolutionsIcon />,
   },
   {
      title: "AI-Powered Gaming Insights",
      subtitle: "Smart Analytics and Player Trends",
      description:
         "We implement AI-driven analytics that analyze gameplay data, user engagement, and in-game economics, optimizing player retention.",
      icon: <AIPoweredGamingIcon />,
   },
   {
      title: "Secure & Blockchain Gaming",
      subtitle: "NFTs, Smart Contracts & Tokenization",
      description:
         "We develop secure blockchain-based gaming platforms that support NFT assets, crypto-based rewards, and decentralized transactions.",
      icon: <SecureBlockchainGamingIcon />,
   },
   {
      title: "Seamless Multiplayer Integration",
      subtitle: "Real-Time Matchmaking & Leaderboards",
      description:
         "We create multiplayer gaming solutions with real-time matchmaking, global leaderboards, and AI opponent balancing.",
      icon: <SeamlessMultiplayerIntegrationIcon />,
   },
   {
      title: "Scalable Cloud-Based Solutions",
      subtitle: "Lag-Free Gaming and High Performance",
      description:
         "Low latency, real-time multiplayer support, and engaging streaming are all guaranteed by our cloud gaming infrastructure.",
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: "Continuous Support & Enhancements",
      subtitle: "Feature Updates and Bug Fixes",
      description:
         "We provide 24/7 technical support, security updates, and feature enhancements to keep gaming and sports platforms competitive and future-ready.",
      icon: <ContinuousSupportIcon />,
   },
]; 

function GameWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Choose Our Gaming & Sports Software Development Services?'
            }
            desc={
               'We develop secure, scalable, and innovative gaming and sports solutions that enhance user engagement, optimize performance, and revolutionize game development. Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default GameWhyChoose
